import {
  BeverageType,
  EnergyType,
  MealType,
  NonRecyclableWasteType,
  RecyclableWasteType,
} from '@/domain/impact-co2/entities/question.entity';

export type VenueMonthDeclaration = {
  id: number;
  co2: VenueCo2MonthValues;
};

export type VenueCo2MonthValues = {
  cateringMeal: ValuesCateringMeal;
  cateringBeverage: ValuesCateringBeverage;
  energy: ValuesEnergy;
  water: ValuesWater;
  wasteRecyclable: ValuesRecyclableWaste;
  wasteNonRecyclable: ValuesNonRecyclableWaste;
  digital: ValuesDigital;
};

export type ValuesCateringMeal = {
  sector: string;
  mealType: MealType;
  mealCount: number;
}[];

export type ValuesCateringBeverage = {
  sector: string;
  beverageType: BeverageType;
  beverageCount: number;
}[];

export type ValuesWater = {
  sector: string;
  waterConsumptionVolume: number;
};

export type ValuesEnergy = {
  sector: string;
  energyType: EnergyType;
  energyConsumptionQuantity: number;
}[];

export const CustomEnergyTypeValues: EnergyType[] = [
  'ELECTRICITY_NETWORK_FRANCE',
  'GAS',
  'PHOTOVOLTAIC_ELECTRICITY',
];

export type ValuesRecyclableWaste = {
  sector: string;
  recyclableWasteType: RecyclableWasteType;
  recyclableWasteQuantity: number;
}[];

export type ValuesNonRecyclableWaste = {
  sector: string;
  nonRecyclableWasteType: NonRecyclableWasteType;
  nonRecyclableWasteQuantity: number;
}[];

export type ValuesDigital = {
  sector: string;
  dataUsage: number;
  videoViews: number;
};
